import type React from 'react';
import styled from 'styled-components';
import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity.ts';
import { observer } from 'mobx-react';
import { useInjection } from 'inversify-react';
import type { StepsListController } from './StepsList.controller';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { TYPES } from '@/engine/ioc';
import { StepButton } from '@mui/material';

export const StepsList: React.FC = observer(() => {
  const stepsListController = useInjection<StepsListController>(TYPES.StepsListController);
  const views: Array<ViewEntity> = stepsListController.views;
  const currentDescriptor = stepsListController.getCurrentView?.getDescriptor();
  return (
    <Container>
      <StyledStepper activeStep={stepsListController.currentViewIndex} nonLinear={true}>
        {views.map((v) => {
          const descriptor = v.getDescriptor();
          const isDisabled = !stepsListController.isViewEnabled(descriptor);
          return (
            <Step key={v.id.toString()} disabled={isDisabled} completed={v.getApprovedStatus()}>
              <StepButton
                color="inherit"
                role="button"
                aria-label={v.getLabel()}
                aria-selected={currentDescriptor === descriptor}
                data-testid={descriptor}
                onClick={(): void => {
                  // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
                  stepsListController.setCurrentView(v);
                }}
              >
                {v.getLabel()}
              </StepButton>
            </Step>
          );
        })}
      </StyledStepper>
    </Container>
  );
});

const Container = styled.div`
  display: block;
  width: 100%;
  padding: 0 1em;
  pointer-events: auto;
`;

const StyledStepper = styled(Stepper)`
  & .Mui-disabled,
  & .Mui-disabled > svg {
    color: ${({ theme }): string => theme.disabledFont};
    & .MuiStepIcon-text {
      fill: ${({ theme }): string => (theme.mode === 'dark' ? '#666' : '#fff')};
    }
  }
  & .MuiStep-root .Mui-completed {
    color: ${({ theme }): string => theme.palette.success.main};
  }
  & .MuiStepLabel-labelContainer span {
    color: ${({ theme }): string => theme.customPalette.panels.stepper.font};
  }
  & .MuiStepLabel-labelContainer .Mui-disabled {
    color: ${({ theme }): string => theme.disabledFont};
  }
  & .MuiStepLabel-iconContainer {
    transform: scale(1.1);
  }
`;
